module.exports = __webpack_public_path__ + "img/sv3.6583c2c4.svg";